// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"980b2ae3","703":"6f2b6c3d"}[chunkId] + ".chunk.js";
};